import { useQuery } from '@tanstack/react-query';
import { getClinicalSites } from '../services/clinical_sites';

export const GetClinicalSitesByOrg = () => {
  return useQuery({
    queryKey: ['clinicalSites'],
    queryFn: getClinicalSites,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
  });
};
